module.exports = __webpack_public_path__ + "teqbahn-assets/media/gi5.fbd556bf.png";